import { validateOrderExport } from "../validators/orderExportValidator";
import type { OrderExportForm } from "../types/orderExportTypes";

export const useOrderExportValidation = (form: OrderExportForm, submitted: boolean) => {
  const errors = validateOrderExport(form);
  return { errors, showErrors: submitted };
};
